export default __webpack_public_path__ + "static/media/objetivos.58802ace.png";